export default "__VITE_ASSET__DbsFLbK5__"